import { Search, Megaphone, TrendingUp, MapPin, MonitorSmartphone, BarChart3, MousePointerClick, Stethoscope, Sparkles, Server, Globe, Link2 } from "lucide-react";

const MAP = { Search, Megaphone, TrendingUp, MapPin, MonitorSmartphone, BarChart3, MousePointerClick, Stethoscope, Server, Globe, Link2 };

export const ServiceIcon = ({ name, className }) => {
  const I = MAP[name] || Sparkles;
  return <I className={className} aria-hidden />;
};
